import accessibleAutocomplete from "accessible-autocomplete";

window.customElements.define(
    "autocomplete-select",
    class extends HTMLElement {
        connectedCallback() {
            const selectElement = this.querySelector<HTMLSelectElement>("select");

            if (!selectElement) {
                return;
            }

            const placeholderOption = Array.from(selectElement.options).find((option) => option.value === "");
            const placeholder = placeholderOption?.textContent || placeholderOption?.innerText || "";

            accessibleAutocomplete.enhanceSelectElement({
                selectElement,
                defaultValue: "",
                placeholder,
                displayMenu: "overlay",
                showAllValues: true,
                onConfirm: (query) => {
                    const requestedOption = Array.from(selectElement.options)
                        .find((option) => (option.textContent || option.innerText) === query);

                    if (!requestedOption) {
                        return;
                    }

                    requestedOption.selected = true;
                    selectElement.dispatchEvent(new Event("change", { bubbles: true }));
                },
            });

            const autocompleteWrapper = selectElement.previousElementSibling;

            autocompleteWrapper?.classList.add(...Array.from(selectElement.classList));
        }
    },
);
